import { type RouteConfig } from 'vue-router'

export const DashboardAnalyticsRouter: RouteConfig[] = [
  {
    path: '/dashboardAnalytics',
    component: async () => import('./DashboardAnalytics.vue'),
  },
]
